import i18next from "i18next";
const Footer = () => {
  return (
    <footer class="footer-area text-center text-md-start bg-white">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="col-md-6 col-lg-6">
          <p class="text-body-secondary fw-medium mb-0">
            {i18next.t("copyright")}
            <a
              href="https://www.idoogroup.com/"
              rel="noreferrer"
              class="text-decoration-none fw-bold transition"
              target="_blank"
            >
              IdooGroup
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
